import styled from 'styled-components'

interface TextProps {
  darkFont?: boolean
  opacity?: number
  margin?: number
  marginTop?: number
  marginBottom?: number
  fontWeight?: number
  fontSize?: number
  fontStyle?: string
}

export const DesktopTitleMedium = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: ${(props): number => (props.fontWeight !== undefined ? props.fontWeight : 700)};
  line-height: normal;
  color: ${(props): string => (props.darkFont ? 'var(--fightback-black)' : 'var(--white)')};
  opacity: ${(props): number => (props.opacity !== undefined ? props.opacity : 1)};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopDisplayLarge = styled.h1<TextProps>`
  font-family: 'Sora', sans-serif;
  font-size: 5rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--fightback-white);
  opacity: ${(props): number => (props.opacity !== undefined ? props.opacity : 1)};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopTitleLarge = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: ${(props): string =>
    props.fontSize !== undefined ? `${props.fontSize}rem` : '1.5rem'};
  font-style: 'normal';
  font-weight: 700;
  line-height: normal;
  color: ${(props): string => (props.darkFont ? 'var(--fightback-black)' : 'var(--white)')};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopBodyLarge = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-style: ${(props): string =>
    props.fontStyle !== undefined ? `${props.fontStyle}` : 'normal'};
  font-weight: ${(props): number => (props.fontWeight !== undefined ? props.fontWeight : 500)};
  line-height: 1.5rem;
  color: ${(props): string => (props.darkFont ? 'var(--fightback-black)' : 'var(--white)')};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopBodyMedium = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: ${(props): number => (props.fontWeight !== undefined ? props.fontWeight : 600)};
  line-height: 0.75rem;
  color: ${(props): string => (props.darkFont ? 'var(--fightback-black)' : 'var(--white)')};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopHeadlineLarge = styled.h1<TextProps>`
  font-family: 'Sora', sans-serif;
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--fightback-white);
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const DesktopButton = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: ${(props): string => (props.fontSize !== undefined ? `${props.fontSize}rem` : '1rem')};
  font-style: normal;
  font-weight: 700;
  line-height: 1.25rem;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileHeadlineLarge = styled.h1<TextProps>`
  font-family: 'Sora', sans-serif;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  opacity: ${(props): number | undefined => (props != null ? props.opacity : 1)};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileTitleLarge = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileTitleMedium = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: ${(props): number => (props.fontWeight !== undefined ? props.fontWeight : 700)};
  line-height: normal;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileDisplayLarge = styled.h1<TextProps>`
  font-family: 'Sora', sans-serif;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  opacity: ${(props): number => (props.opacity !== undefined ? props.opacity : 1)};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileBodyLarge = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-style: ${(props): string =>
    props.fontStyle !== undefined ? `${props.fontStyle}` : 'normal'};
  font-weight: ${(props): number => (props.fontWeight !== undefined ? props.fontWeight : 500)};
  line-height: normal;
  color: var(--white);
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

export const MobileButton = styled.h1<TextProps>`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 0.9rem;
  color: ${(props): string =>
    props.darkFont ? 'var(--fightback-black)' : 'var(--fightback-white)'};
  margin: ${(props): string => getMargin(props.margin, '0')};
  margin-top: ${(props): string => getMargin(props.marginTop, getMargin(props.margin, '0'))};
  margin-bottom: ${(props): string => getMargin(props.marginBottom, getMargin(props.margin, '0'))};
`

function getMargin(margin: number | undefined, alternative: string): string {
  return margin !== undefined ? `${margin}rem` : alternative
}
